import React from "react";

export function Records() {
    return (
        <>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
        <center>
        <a href="https://main.govpilot.com/web/public/4b3bc158-5b9_Open-Records-Request-MONROEMIDDLESEX?uid=8942&ust=NJ&pu=1&id=1
"><button>Open Public Records Request (OPRA) Form</button></a>
        <br/>
        </center>
        </>
    )
}